import { FaGoogle, FaMicrosoft, FaVideo } from "react-icons/fa";
import { SiZoom } from "react-icons/si";

import type {
  MeetingUrl,
  MicrosoftTeamsLiveUrl,
  MicrosoftTeamsUrl,
} from "@frontierx/shared/types";

export interface CallServiceIconProps {
  url: string | MeetingUrl;
}

function getMicrosoftTeamsDisplayId(
  meetingUrl: MicrosoftTeamsUrl | MicrosoftTeamsLiveUrl,
) {
  const { meeting_id, thread_id, message_id, business_meeting_id, tenant_id } =
    meetingUrl;
  if (meeting_id) {
    return meeting_id;
  }
  if (business_meeting_id) {
    return business_meeting_id;
  }
  if (thread_id) {
    return thread_id;
  }
  if (message_id) {
    return message_id;
  }
  return tenant_id ?? "Unknown";
}

function meetingUrlToDisplayId(meetingUrl: MeetingUrl) {
  const { platform, meeting_id } = meetingUrl;
  if (platform === "zoom" && meeting_id) {
    return meeting_id;
  }

  if (platform === "google_meet" && meeting_id) {
    return meeting_id;
  }

  if (platform === "microsoft_teams" || platform === "microsoft_teams_live") {
    return (
      getMicrosoftTeamsDisplayId(meetingUrl).split(":meeting_")[1] ?? "unknown"
    );
  }
  return "Unknown";
}

export function CallServiceIcon({ url }: Readonly<CallServiceIconProps>) {
  if (typeof url === "string") {
    let hostname: string | undefined;
    try {
      const parsedUrl = new URL(url.trim());
      hostname = parsedUrl?.hostname;
    } catch (e) {
      console.error("Error parsing URL", e);
    }

    if (hostname?.includes("google")) {
      return (
        <div className="flex items-center">
          <FaGoogle className="mr-2" />
        </div>
      );
    }
    if (hostname?.includes("zoom")) {
      return (
        <div className="flex items-center">
          <SiZoom className="mr-2" />
        </div>
      );
    }
    if (hostname?.includes("teams.live.com")) {
      return (
        <div className="flex items-center">
          <FaMicrosoft className="mr-2" />
        </div>
      );
    }
    if (hostname?.includes("teams.microsoft")) {
      return (
        <div className="flex items-center">
          <FaMicrosoft className="mr-2" />
        </div>
      );
    }
    // Default case for unsupported or unknown services
    return (
      <div className="flex items-center">
        <FaVideo className="mr-2" />
      </div>
    );
  }

  const { platform } = url;

  if (platform === "google_meet") {
    return (
      <div className="flex items-center">
        <FaGoogle className="mr-2" />
      </div>
    );
  }
  if (platform === "zoom") {
    return (
      <div className="flex items-center">
        <SiZoom className="mr-2" />
      </div>
    );
  }
  if (platform === "microsoft_teams" || platform === "microsoft_teams_live") {
    return (
      <div className="flex items-center">
        <FaMicrosoft className="mr-2" />
      </div>
    );
  }
  // Default case for unsupported or unknown platforms
  return (
    <div className="flex items-center">
      <FaVideo className="mr-2" />
    </div>
  );
}
